import request from '@/utils/request'
export function getHistoryList(params) {
	return request.get('audit/list', {
		params
	})
}

export function deleteReport(data) {
	return request.post('audit/deleteApply', data)
}